import React from 'react';
import WikiAccordion from './WikiAccordion';
import '../App.css';

export default function WikiModal({ show, onClose }) {
  if (!show) return null;

  return (
    <div className="wiki-modal-backdrop">
      <div className="wiki-modal-content">
        <button className="wiki-modal-close" onClick={onClose}>✖</button>
        <WikiAccordion />
        <button
          onClick={() => onClose(null)}
          className="modal-close-btn"
        >
          Close
        </button>
      </div>
    </div>
  );
}
